import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Spinner } from "reactstrap";
import { CheckCircle, AlertCircle, RefreshCw } from "react-feather";
import NextStepCard from "./NextStepCard";

const NextSteps = ({ steps, isLoading, error, onRetry }) => {
  if (isLoading) {
    return (
      <div className="figma-next-steps-outer-box" id="brand-next-steps-section">
        <div className="figma-section-label">YOUR NEXT STEPS</div>
        <div className="d-flex justify-content-center align-items-center py-4 bg-white rounded border" style={{ minHeight: "160px" }}>
          <Spinner color="primary" />
        </div>
      </div>
    );
  }

  if (error && (!steps || !steps.length)) {
    return (
      <div className="figma-next-steps-outer-box" id="brand-next-steps-section">
        <div className="figma-section-label">YOUR NEXT STEPS</div>
        <div className="p-2 text-center bg-white rounded border d-flex flex-column align-items-center justify-content-center">
          <AlertCircle size={22} className="text-danger mb-50" />
          <span className="font-weight-bold text-dark mb-25 font-small-3">Failed to load next steps</span>
          <p className="text-muted font-small-2 mb-75">
            {typeof error === "string" ? error : error?.message || "Could not retrieve your next steps."}
          </p>
          {onRetry && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
              onClick={onRetry}
            >
              <RefreshCw size={12} className="mr-50" />
              <span>Retry</span>
            </button>
          )}
        </div>
      </div>
    );
  }

  if (!steps || !steps.length) {
    return (
      <div className="figma-next-steps-outer-box" id="brand-next-steps-section">
        <div className="figma-section-label">YOUR NEXT STEPS</div>
        <div className="p-2 text-center bg-white rounded border d-flex align-items-center justify-content-center">
          <CheckCircle size={20} className="text-success mr-75" />
          <span className="font-weight-bold text-dark">You're all caught up! No pending actions right now.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="figma-next-steps-outer-box" id="brand-next-steps-section">
      <div className="figma-section-label">YOUR NEXT STEPS</div>

      <Row className="next-steps-row">
        {steps.map((step, index) => (
          <Col md="6" xs="12" key={step.id || index} className="next-step-col mb-1 mb-md-2">
            <NextStepCard
              step={step}
              stepNumber={step.step_number || index + 1}
              isHero={Boolean(step.is_hero || index === 0)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

NextSteps.propTypes = {
  steps: PropTypes.array
};

NextSteps.defaultProps = {
  steps: []
};

export default NextSteps;
